module.exports = __webpack_public_path__ + "static/media/human5.8b484a91.jpg";